import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";
import boxhtml from "ulysses/box.html";
import "ulysses/controls/textinput";
import "ulysses/actions/data_actions";

"use strict";
uly.utils = $.extend(uly.utils, {
    debounced_call: function debounced_call(callback, timeout) {
        var last_call = null;
        var last_val = null;
        timeout = timeout || 300;
        return function () {
            var cstamp = Date.now();
            if (last_call && (cstamp - last_call) < timeout) {
                return last_val;
            }
            last_call = cstamp;
            last_val = callback.apply(this, arguments);
            return last_val;
        };
    }
});

uly.actions = $.extend(uly.actions, {
    get_$elt_and_ui: function get_$elt_and_ui(ev, ui, action_name) {
        var $elt = $(ev.target);
        var action_model = null;
        if (uly && uly.api) {
            if (ui && ui.model) {
                if (ko.unwrap(ui.model.set) && ko.unwrap(ui.model.name))
                    action_model = ui.model;
            }
            if (!action_model) {
                if (!ui) ui = {};
                ui.data_model = ui.model;
                ui.model = uly.api.start().follow("uly:actions").follow("find", {
                    rel: action_name
                });
            }

        }
        if(!ui) {
            ui = {};
        }
        if (!ui.context) {
            ui.context = ko.contextFor(ev.target);
        }
        return [$elt, ui];
    },
    search_for_action: function (name, actions) {
        var a = ko.unwrap(actions) || [];
        for (var i in a) {
            if (a[i].name == name) {
                return a[i];
            }
        }
        return null;
    },
    classifyActions: function (actions, entity, skip_permission) {
        var data = {};
        var entity_permissions = [];
        if (entity)
            entity_permissions = ko.unwrap(entity.permissions) || [];
        var current_roles = [];
        if (uly.page.userprofile) {
            current_roles = ko.unwrap(uly.page.userprofile.roles) || [];
        }
        var actions = ko.unwrap(actions);
        if (actions && !$.isArray(actions)) {
            actions = [actions];
        }
        actions = $.each(ko.unwrap(actions) || [], function (idx, action) {
            var set = ko.unwrap(action.set);
            var permission = ko.unwrap(action.permission);
            var action_roles = ko.unwrap(action.roles) || [];
            if (entity && permission && !skip_permission && entity_permissions.indexOf(permission) < 0) {
                set = false;
            }
            if (set && action_roles.length > 0) {
                var found = false;
                $.each(action_roles, function (idx, r) {
                    if (current_roles.indexOf(r) >= 0) {
                        found = true;
                        return false;
                    }
                });
                if (!found) {
                    set = false;
                }
            }
            if (set) {
                set = set.replace(/relation:/, "");
                if (data[set]) {
                    data[set].push(action);
                } else data[set] = [action];
                if (set == "default") {
                    if (!data.extra)
                        data.extra = [];
                    data.extra.push(action);
                }
                if (ko.unwrap(action.bulk_action)) {
                    if (!("bulk_actions" in data))
                        data.bulk_actions = [];
                    data.bulk_actions.push($.extend(action, {
                        count: 0
                    }));
                }
            }
        });
        return data;
    },
    togglewidesidebar: function(e, $elt, ui) {
        uly.page.ui_state.wide_sidebar(!uly.page.ui_state.wide_sidebar());
    },
    navigateto: function (e, $elt, ui) {

        if ($elt && $elt.hasClass("badge")) {
            e.preventDefault();
            e.stopPropagation();
        }
        var tmp_state;
        var destination = null;
        if (uly.utils.is_type(e, "String")) {
            destination = e;
            tmp_state = uly.history.get_temporary_state(e);
        } else if ($elt && $elt.data() && "link" in $elt.data() && $elt.data().link) {
            destination = $elt.data().link;
            tmp_state = uly.history.get_temporary_state($elt.data());
        } else if ($elt && $elt.attr("href")) {
            destination = $elt.attr("href");
            tmp_state = uly.history.get_temporary_state($elt.attr("href"));
        }
        if (destination && uly.utils.is_link_external(destination)) {
            if (navigator.app && navigator.app.loadUrl) {
                //running on cordova. need to open the external browser
                //this doesn't work
                //window.open(destination, "_system");
                //this does on android:
                navigator.app.loadUrl(destination, {
                    "openExternal": true
                });
            } else {
                //open in new tab.
                window.open(destination, "_blank");
            }
        } else if (tmp_state) {
            if (destination == "login" || destination == "/login") {
                uly.actions.login();
            } else {
                var s = uly.history.get_state();
                if (s.url === tmp_state.url) {
                    uly.page.reload();
                    //uly.publish("history.replacestate", tmp_state);
                } else {
                    uly.publish("history.pushstate", tmp_state);
                }
            }
        }
    },
    logout: function (e, ui) {
        uly.api.start().follow("uly:app").put("uly:signout").then(function (res) {
            delete sessionStorage.token;
            delete localStorage.token;
            //delete everything
            sessionStorage.clear();
            localStorage.clear();
            uly.page.clear_settings();
            uly.page.userprofile.username(null);
            uly.api.token = null;
            uly.actions.goto("login");
        }, function(res) {
            delete sessionStorage.token;
            delete localStorage.token;
            //delete everything
            sessionStorage.clear();
            localStorage.clear();
            uly.page.clear_settings();
            uly.page.userprofile.username(null);
            uly.api.token = null;
            uly.actions.goto("login");
        });
    },
    goto: function (e, $elt, ui) {
        return uly.actions.navigateto(e, $elt, ui);
    },
    addwidget: function (e, $elt, ui) {
        var tmp = [];
        $.each(uly.widgets.get_visible_widgets(), function () {
            tmp.push({
                "$data": this
            });
        });
        tmp.sort(function (a, b) {
            if (a.$data.caption > b.$data.caption) return 1;
            if (a.$data.caption < b.$data.caption) return -1;
            return 0;
        });
        var dialog = uly.dialogs.execute(
            "<!-- ko foreach: $data -->" + $("<div>").addClass("col-md-4 col-xs-6 modal-box").html(boxhtml)[0].outerHTML + "<!-- /ko -->", {
                "title": _("action_title_add_a_widget_inside_your_workspace", "Add a widget inside your workspace"),
                buttons: [{
                    "button": "cancel",
                    "caption": _("action_caption_cancel", "Cancel"),
                    "button_class": "btn",
                    "icon": "fa fa-times-circle",
                    "action": "closedialog"
                }]
            },
            tmp
        );

        dialog.$elt.find(".widget-box").bind("click", function (e) {
            e.preventDefault();
            var data = ko.dataFor(this);
            data.$data.init(e, data.$data).done(function (settings) {
                dialog.$elt.trigger("hidden.bs.modal");
                uly.page.settings.left.unshift($.extend(data.$data, settings));
                uly.publish("page.savesettings");
                uly.utils.show_results({
                    success: true,
                    info: _("action_widget_added_successfully", "Widget {0} added successfully!").format(data.$data.type())
                });
            }).fail(function (error) {
                dialog.$elt.trigger("hidden.bs.modal");
                uly.utils.show_results(error);
            });
        });
    },
    switchpagelayout: function (e, $elt, ui) {
        e.preventDefault();
        var layout = ko.unwrap(uly.page.settings.layout);
        var dialog = uly.dialogs.execute(
            $("#dlg-layout-switch-tmpl").html(), {
                "title": _("action_title_switch_page_layout", "Switch page layout"),
            }, {
                "layout": layout
            }).done(function ([result]) {
            if (ko.unwrap(result.layout)) {
                uly.page.settings.layout(ko.unwrap(result.layout));
                uly.publish("page.savesettings");
            }
        });
    },
    switchtheme: function (e, $elt, ui) {
        var vals = uly.actions.get_$elt_and_ui(e, ui, "switchtheme");
        $elt = vals[0];
        ui = vals[1];

        uly.actions.standard_action(e, $elt, ui).then(function (result) {
            document.location.reload();
        });

    },
    redirect: function (data) {
        if ("entity" in data && data.entity)
            data = data.entity;
        if ("__unique_id" in data && data.__unique_id) {
            uly.actions.navigateto(data.__unique_id.replace("#", "/"));
        } else if ("type_" in data && data.type_ && "id" in data && data.id) {
            uly.actions.navigateto(data.type_ + "/" + data.id);
        }
    },
    get_standard_ids: function (ev, $elt, ui) {
        var action = ui.model;
        var entity_model = ui.entity_model ? ui.entity_model : uly.utils.get_bound_entity($elt);
        if (entity_model && !Array.isArray(entity_model)) {
            entity_model = [entity_model];
        }

        var ids = [];
        if (action.context) {
            if (ui[action.context]) {
                ids = [ui[action.context]];
            } else if (entity_model) {
                $.each(entity_model, function (idx, value) {
                    if (value[action.context]) {
                        ids.push(value[action.context]);
                    }
                });
            }
        } else {
            if (ui.unique_id) {
                ids = [ui.unique_id];
            } else if (ui.type_ && ui.id) {
                ids = [ui.type_ + "#" + ui.id];
            } else {
                ids = [];
                if (entity_model) {
                    ids = $.map(entity_model, function (value, idx) {
                        if (value.content_type == "collection")
                            return ko.unwrap(value.type);
                        return ko.unwrap(value.unique_id);
                    });
                }
            }
        }
        return ids;

    },
    "gohome": function (ev, $elt, ui) {
        if (uly.page.userprofile) {
            var home = ko.unwrap(uly.page.userprofile.home_page);
            if (home) {
                uly.goTo(home);
            }
        }
    },
    "signup": function (ev, $elt, ui) {
        var def = Promise.Deferred();
        uly.api.start().follow("uly:actions").follow("find", {
            "rel": "signup"
        }).done(function (action) {
            ui.model = action;
            uly.actions.standard_action(ev, $elt, ui).done(def.resolve).fail(def.reject);
        }).fail(function (args) {
            console.warn("standard action failure:", args);
            def.reject(args);
        });
        return def.promise();
    },
    "search": function (ev, $elt, ui) {
        var filter = ko.unwrap(ui.model.filters);

        if (uly.page.userprofile) {
            uly.goTo("/search", {
                "filters": filter
            });
        }
    },
    "executeactiontemplate": function (ev, $elt, ui) {}
});
ko.bindingHandlers.renderaction = {
    init: function (elt, va, bindings, model, context) {
        var hal_entity = HalResource(ko.dataFor(elt));
        hal_entity.follow_with_cache("uly:actions", uly.api.action_cache).done(function (actions) {
            var action = uly.actions.search_for_action(ko.unwrap(va()), actions);
            if (action) {

                "<a data-bind=\"action:$data.name, colour:$data.colour, class_prefix:'btn-'\"  class=\"btn btn-sm \"><i data-bind=\"icon:$data.icon\"></i></a>";

                $(elt).html("<a data-bind=\"action:$data.name, colour:$data.colour, class_prefix:'btn-'\"  class=\"btn btn-sm \"><i data-bind=\"icon:$data.icon\"></i></a>");
                var childContext = context.createChildContext(action);
                ko.applyBindingsToDescendants(childContext, elt);
            } else {
                $(elt).remove();
            }
        }).fail(function () {
            $(elt).remove();
        });
        return {
            controlsDescendantBindings: true
        };
    }
};
ko.bindingHandlers.action = {
    init: function (elt, va, bindings, model, context) {
        var action = ko.unwrap(va()),
            selected = bindings().selected ? ko.unwrap(bindings().selected) : [];
        var side_effect = bindings().side_effect;
        if (!action) {
            return;
        }
        var callback = (typeof action == "function") ? action : (function (e, ui) {
            e.preventDefault();
            var bubble = bindings.get("actionBubble") !== false;
            if (!bubble) {
                e.cancelBubble = true;
                if (e.stopPropagation)
                    e.stopPropagation();
            }
            var aname = null;
            if (action && uly.utils.is_type(action, "Object")) {
                aname = action.action_name || action.name;
            } else if (typeof action == "string") {
                aname = action;
            }
            if (uly.actions[aname]) {
                uly.actions[aname](e, $(elt), ui);
            } else {
                $(elt).trigger("action:" + aname, ui);
            }
            if (side_effect) {
                try {
                    return side_effect(e,ui);
                } 
                catch(e) {
                    console.error(e);
                }
            }
        });
        $(elt).css("cursor", "pointer");

        callback = uly.utils.debounced_call(callback);
        $(elt).off("click tap").on("click tap", function (e, ui) {
            uly.reset_timeout();
            ui = ui || {};
            ui.model = model;
            ui.context = context;
            ui.selected = bindings().selected;
            callback(e, ui);
            //return false;
        });
    }
};
